module.exports = __webpack_public_path__ + "img/forticloud.c8afa564.png";